'use strict';

angular.module('safeApply', [])
    .service('safeApply', ['$rootScope', function($rootScope) {
        return function(cb, $scope) {
            $scope = $scope || $rootScope;
            if ($rootScope.$$phase) {
                cb && $scope.$evalAsync(cb);
            } else {
                $scope.$apply(cb);
            }
        }
    }])
    .run(['$rootScope', function($rootScope) {
        $rootScope.$safeApply = function(cb) {
            if ($rootScope.$$phase) {
                cb && this.$evalAsync(cb);
            } else {
                this.$apply(cb);
            }
        };
    }]);
